const ERROR_COMPRA_KEY = 'errorCompra';

const hasWindow = typeof window !== 'undefined';

const safeGetSessionStorage = () => {
  if (!hasWindow) return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const safeGetLocalStorage = () => {
  if (!hasWindow) return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

export const getErrorCompraRaw = (): string | null => {
  return safeGetSessionStorage()?.getItem(ERROR_COMPRA_KEY) ?? null;
};

export const getErrorCompra = (): string | null => {
  const raw = getErrorCompraRaw();
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'string' ? parsed : raw;
  } catch {
    return raw;
  }
};

export const hasErrorCompra = (): boolean => Boolean(getErrorCompraRaw());

export const setErrorCompra = (message: string) => {
  safeGetSessionStorage()?.setItem(ERROR_COMPRA_KEY, JSON.stringify(message));
};

export const clearErrorCompra = () => {
  safeGetSessionStorage()?.removeItem(ERROR_COMPRA_KEY);
  // Backward-compat: historically some code removed it from localStorage.
  safeGetLocalStorage()?.removeItem(ERROR_COMPRA_KEY);
};

